module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("VUX V2.7.0 released")]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/calendar.html"
    }
  }, [_vm._v("Calendar")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[fix] fix top border #2104")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/cell.html"
    }
  }, [_vm._v("Cell")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[fix] fix ssr rendering issue")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/checklist.html"
    }
  }, [_vm._v("Checklist")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[fix] fix default selected item missing issue #2122")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/datetime.html"
    }
  }, [_vm._v("Datetime")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[fix] fix ssr i18n bug")]), _vm._v(" "), _c('li', [_vm._v("[fix] fix datetime still shows when prop:readonly is true #2079")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/flow.html"
    }
  }, [_vm._v("Flow")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] add slot:title for flow-state #2010")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/inline-calendar.html"
    }
  }, [_vm._v("InlineCalendar")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[enhance] call render function on created hook instead of mounted(ssr)")]), _vm._v(" "), _c('li', [_vm._v("[feature] add prop:disable-weekend #2105")]), _vm._v(" "), _c('li', [_vm._v("[feature] add prop:disable-date-function #2105")]), _vm._v(" "), _c('li', [_vm._v("[fix] remove useless re-render function #2066")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/picker.html"
    }
  }, [_vm._v("Picker")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[change] picker move distance do not respect html[data-dpr] by default #2082 #1979")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/popup-picker.html"
    }
  }, [_vm._v("PopupPicker")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] add prop:popup-title(use component:popup-header) #1866")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/popup-radio.html"
    }
  }, [_vm._v("PopupRadio")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[fix] fix vue@2.5.0 scope issue #2076")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/qrcode.html"
    }
  }, [_vm._v("Qrcode")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[fix] fix errors when value is undefined #2070")]), _vm._v(" "), _c('li', [_vm._v("[change] use style to set width and height #2075")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/selector.html"
    }
  }, [_vm._v("Selector")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[fix] fix ssr rendering issue")]), _vm._v(" "), _c('li', [_vm._v("[fix] fix placeholder not show when value is null #2101")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/swiper.html"
    }
  }, [_vm._v("Swiper")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[enhance] set shorter distance for first and last item for better experience")]), _vm._v(" "), _c('li', [_vm._v("[feature] add event:on-get-height #2112")]), _vm._v(" "), _c('li', [_vm._v("[enhance] stop interval if auto is set to false #2027")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/x-address.html"
    }
  }, [_vm._v("XAddress")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[fix] fix vue@2.5.0 scope issue #2076")]), _vm._v(" "), _c('li', [_vm._v("[feature] add prop:popup-title(use component:popup-header) #1866")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/x-dialog.html"
    }
  }, [_vm._v("XDialog")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] add event:on-click-mask #2102")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/x-switch.html"
    }
  }, [_vm._v("XSwitch")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] support prop:value-map #2104")])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3166578c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/ream/~/vue-loader/lib/template-compiler?{"id":"data-v-3166578c"}!./~/ream/~/vue-loader/lib/selector.js?type=template&index=0!./~/v-markdown-loader/_cache/v2.7.0-129.vue
// module id = 2125
// module chunks = 253